import React, { useState, useEffect } from 'react';
import { db } from '../Firebase'; // Adjust path as needed
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useUser } from '../UserContext';
import { useNavigate } from 'react-router-dom';
function AddNewHub() {
  const [formData, setFormData] = useState({
    hubName: '',
    hubPlace: '',
    hubOpenTime: '',
    hubCloseTime: '',
    hubOpenDate: [],
    services: []
  });
  const {userData,currentUser} = useUser()
  const [currentService, setCurrentService] = useState('');
  const [currentService2, setCurrentService2] = useState('');
  const [currentService3, setCurrentService3] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (submitStatus?.type === 'success') {
      const timer = setTimeout(() => setSubmitStatus(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [submitStatus]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const composedServices = [currentService, currentService2, currentService3]
      .map(s => s.trim())
      .filter(Boolean);
    
    try {
      await addDoc(collection(db, 'hubs'), {
        ...formData,
        services: composedServices,
        createdAt: serverTimestamp(),
        createdBy:userData?.name,
        createdById:currentUser.uid
      });
      
      setSubmitStatus({ type: 'success', message: 'Hub added successfully!' });
      // Reset form
      setFormData({
        hubName: '',
        hubPlace: '',
        hubOpenTime: '',
        hubCloseTime: '',
        hubOpenDate: [],
        services: []
      });
      setCurrentService('');
      setCurrentService2('');
      setCurrentService3('');
    } catch (error) {
      console.error('Error adding hub: ', error);
      setSubmitStatus({ type: 'error', message: 'Failed to add hub. Please try again.' });
    } finally {
      setIsSubmitting(false);
      navigate('/hubs');
    }
  };

  const handleReset = () => {
    setFormData({
      hubName: '',
      hubPlace: '',
      hubOpenTime: '',
      hubCloseTime: '',
      hubOpenDate: [],
      services: []
    });
    setCurrentService('');
    setCurrentService2('');
    setCurrentService3('');
    setSubmitStatus(null);
  };

  const composedServicesPreview = [currentService, currentService2, currentService3]
    .map(s => s.trim())
    .filter(Boolean);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <section className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white">
          <h2 className="text-2xl font-bold">Add a New Local Hub</h2>
          <p className="text-blue-100 mt-1">Create a new community hub to connect people with services</p>
        </div>
        
        <form className="p-6" onSubmit={handleSubmit}>
          {submitStatus && (
            <div 
              className={`mb-6 p-4 rounded-lg ${submitStatus.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}
              role="alert"
              aria-live="polite"
            >
              {submitStatus.message}
            </div>
          )}
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="hubName">
                Hub Name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                id="hubName"
                name="hubName"
                type="text"
                placeholder="e.g., Riverdale Community Hub"
                value={formData.hubName}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="hubPlace">
                Hub Place <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                id="hubPlace"
                name="hubPlace"
                type="text"
                placeholder="City, Area"
                value={formData.hubPlace}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="hubOpenTime">
                Hub Open Time
              </label>
              <input
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                id="hubOpenTime"
                name="hubOpenTime"
                type="time"
                value={formData.hubOpenTime}
                onChange={handleInputChange}
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="hubCloseTime">
                Hub Close Time
              </label>
              <input
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                id="hubCloseTime"
                name="hubCloseTime"
                type="time"
                value={formData.hubCloseTime}
                onChange={handleInputChange}
              />
            </div>
            
            <div className="space-y-2">
  <label className="block text-sm font-medium text-gray-700">
    Hub Open Days
  </label>

        <div className="grid grid-cols-2 gap-2">
          {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => (
            <label key={day} className="flex items-center space-x-2">
              <input
                type="checkbox"
                name="hubOpenDate"
                value={day}
                checked={formData.hubOpenDate.includes(day)}
                onChange={(e) => {
                  const { value, checked } = e.target;
                  setFormData((prev) => ({
                    ...prev,
                    hubOpenDate: checked
                      ? [...prev.hubOpenDate, value]   // add day
                      : prev.hubOpenDate.filter((d) => d !== value) // remove day
                  }));
                }}
                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="text-sm text-gray-700">{day}</span>
            </label>
          ))}
        </div>
      </div>

            
            <div className="md:col-span-2 space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="services">
                Services Offered (up to 3)
              </label>
              <div className="relative grid grid-cols-1 md:grid-cols-3 gap-3">
                <input
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  type="text"
                  placeholder="Service 1"
                  value={currentService}
                  onChange={(e) => setCurrentService(e.target.value)}
                />
                <input
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  type="text"
                  placeholder="Service 2"
                  value={currentService2}
                  onChange={(e) => setCurrentService2(e.target.value)}
                />
                <input
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  type="text"
                  placeholder="Service 3"
                  value={currentService3}
                  onChange={(e) => setCurrentService3(e.target.value)}
                />
              </div>
              <p className="text-sm text-gray-500">Examples: Wi‑Fi, Printing, Meeting rooms</p>
              
              {composedServicesPreview.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-3">
                  {composedServicesPreview.map((service, index) => (
                    <div key={index} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
                      <span>{service}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 mt-8">
            <button
              className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition disabled:opacity-50 disabled:cursor-not-allowed"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Adding Hub...' : 'Add Hub'}
            </button>
            <button
              className="flex-1 bg-gray-200 text-gray-800 py-3 px-6 rounded-lg font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition"
              type="button"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}

export default AddNewHub;